import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Terren
 * id 795894B8-2599-4FC8-9B4C-0A0896C6BBB4
 * name rectangle
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rectangle.svg
 * tags
 * - Shape 
 */
export const RectangleIcon = createSvgIcon(<><path d="M4,6V19H20V6H4Z" /></>, 'RectangleIcon');
export default RectangleIcon